import React from 'react';
import { Col } from 'react-grid-system';
import PropTypes from 'prop-types';
import { windowExists } from '../../utils/index';
import Section from '../Section';
import Button from '../Button';
import { ContentCard } from '../Card';

function SidebarSection(props) {
  const {
    content,
    fullBleed,
    sectionTitle,
    sidebar,
  } = props;

  return (
    <Section fullBleed={fullBleed}>
      <Col sm={8}>
        {sectionTitle && (
          <h2>{sectionTitle}</h2>
        )}

        {content && content.map(component => (
          <div
            key={component.id}
            dangerouslySetInnerHTML={{
              __html: component.content.childMarkdownRemark.html,
            }}
          />
        ))}
      </Col>
      <Col sm={4}>
        {sidebar && sidebar.map((component) => {
          if (component.__typename === 'ContentfulCallToActionButton') {
            return (
              <Button
                {...component}
                key={component.id}
                link={component.url}
                isFull
                style={{ marginBottom: '12px' }}
              >
                {component.label}
              </Button>
            );
          }

          if (component.__typename === 'ContentfulCard') {
            let Card = ContentCard;

            if (!windowExists) {
              return null;
            }

            if (typeof component.cardType !== 'undefined') {
              Card = require('../Card')[`${component.cardType}Card`];
            }

            return <Card key={component.id} {...component} />;
          }
          return null;
        })}
      </Col>
    </Section>
  );
}

export default SidebarSection;

SidebarSection.propTypes = {
  content: PropTypes.array,
  fullBleed: PropTypes.bool,
  sectionTitle: PropTypes.string,
  sidebar: PropTypes.array,
};

SidebarSection.defaultProps = {
  fullBleed: false
};
